import {Button, Modal} from "antd";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  .ant-modal-footer {
    border-top: none;
    padding: 16px 24px;
  }
  .ant-modal-footer .ant-btn {
    padding: 16px 24px;
    height: auto;
  }
`;

interface ICreateCustomerAccountModalProps {
  visible: boolean;
  onCancel: () => void;
}

const CreateCustomerAccountModal: React.FC<ICreateCustomerAccountModalProps> = ({
  visible,
  onCancel,
}) => {
  return (
    <StyledModal
      title="No customer dashboard yet"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Got it
        </Button>,
      ]}
      centered
      closable
      bodyStyle={{padding: "24px"}}
    >
      <p>
        You haven&apos;t made any purchase, so your customer dashboard isn&apos;t
        available yet. Once you make a purchase you will be able to switch seamlessly.
      </p>
    </StyledModal>
  );
};

export {CreateCustomerAccountModal};
